import { Table } from '@tiptap/extension-table'

const CustomTable = Table.extend({
  renderHTML({ HTMLAttributes }) {
    return ['table', { class: 'tiptap-table', ...HTMLAttributes }, ['tbody', 0]]
  },
})

export default CustomTable
